import { useEffect, useState } from 'react'

export const useZoom = (columns: number, overrideZoom?: number) => {
    const maxColumns = 20
    const minZoom = 0.4
    const maxZoom = 1.2
    const DEFAULT_ZOOM_BIAS = 0.9

    const calculateDefaultZoom = (cols: number) => {
        const clampedCols = Math.min(Math.max(cols, 1), maxColumns)
        const step = (maxZoom - minZoom) / (maxColumns - 1)

        const rawZoom = maxZoom - (clampedCols - 1) * step

        return Math.max(minZoom, rawZoom * DEFAULT_ZOOM_BIAS)
    }

    const [zoomLevel, setZoomLevel] = useState<number>(overrideZoom !== undefined ? overrideZoom : calculateDefaultZoom(columns))

    useEffect(() => {
        if (overrideZoom !== undefined) {
            setZoomLevel(overrideZoom)
        } else {
            setZoomLevel(calculateDefaultZoom(columns))
        }
    }, [columns, overrideZoom])

    const handleZoomIn = () => setZoomLevel((prev) => Math.min(prev + 0.15, maxZoom))
    const handleZoomOut = () => setZoomLevel((prev) => Math.max(prev - 0.15, minZoom))

    return { zoomLevel, handleZoomIn, handleZoomOut }
}
